import axios from "axios";
import Response from "../../models/response";
import config from "../config";
import { authConfigHeader } from "../Auth";

export const appJsonContentTypeHeader = () => ({
  headers: { "Content-Type": "application/json" },
});

// export async function getAllUsers(){
//     let users = axios
//                     .get(`${config.base_url}/users/all`)
//                     .then(res => res.data.data)
//                     .catch(err => {
//                         console.log(err)
//                         return [];
//                     })
//     return users;
// }

export async function getUser(jwt) {
  console.log(jwt);
  let users = axios
    .get(`${config.base_url}/users/jwt`, authConfigHeader(jwt))
    .then((res) => {
      return res.status === 200
        ? new Response(res.status, "!", res.data.data)
        : new Response(res.status, "Failed!");
    })
    .catch((err) => {
      console.log(err);
      return [];
    });

  return users;
}

export async function getUserById(token, userId) {
  let user = axios
    .get(`${config.base_url}/users/one?id=${userId}`, authConfigHeader(token))
    .then((res) => res.data.data)
    .catch((err) => {
      console.log(err);
      return {};
    });

  return user;
}

export async function getUserLocation(token) {
  let location = axios
    .get(`${config.base_url}/users/long-lat`, authConfigHeader(token))
    .then((res) => res.data.data)
    .catch((err) => {
      console.log(err);
      return {};
    });

  return location;
}

export async function setUserLanguage(token, lang) {
  const resolvedLang = String(lang || localStorage.getItem("i18nextLng") || "en")
    .split("-")[0]
    .toLowerCase();

  return axios
    .put(
      `${config.base_url}/users/language?lang=${resolvedLang}`,
      {},
      authConfigHeader(token)
    )
    .catch((err) => {
      console.log(err);
    });
}

export async function getAllUsers(token) {
  let users = axios
    .get(`${config.base_url}/users/all`, authConfigHeader(token))
    .then((res) => res.data.data)
    .catch((err) => {
      console.log(err);
    });
  return users;
}

export async function ChangeRole(id, role) {
  let changedUser = axios
    .get(
      `${config.base_url}/users/change?id=${id}&role=${role}`
      //authConfigHeader(token)
    )
    .then((res) => res.data.data)
    .catch((err) => {
      console.log(err);
      return {};
    });

  return changedUser;
}
